export const settings = {
    accessibility: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    arrows: true,
    dots: false,
    variableWidth: false,
    adaptiveHeight: false,
    infinite: false,
    responsive: [
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1.33,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false,
                arrows: true,
                variableWidth: false
            }
        }
    ]
}

export const container = {
    show: {
        transition: {
            staggerChildren: 0.2
        }
    }
}

export const product = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            duration: 0.25
        }
    }
}